import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "section estate-detail__slider-section"
}
const _hoisted_2 = {
  key: 0,
  class: "width-wrap"
}
const _hoisted_3 = { class: "estate-slider" }
const _hoisted_4 = { class: "slider-header" }
const _hoisted_5 = { class: "slider-controls" }
const _hoisted_6 = {
  class: "slider-items",
  ref: "scrollContent"
}
const _hoisted_7 = {
  key: 1,
  class: "width-wrap"
}
const _hoisted_8 = { class: "estate-similar-location" }
const _hoisted_9 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdListSimilarItem = _resolveComponent("AdListSimilarItem")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.show && !_ctx.isEstateAgencyMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.hasSimilar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('AdListSimilar.title')), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      class: "slider-prev",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
                    }),
                    _createElementVNode("span", {
                      class: "slider-next",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedList.data, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.adId,
                      class: "slide",
                      to: { name: 'AdDetail', params: { adFrontId: item.adFrontId } },
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AdListSimilarItem, { ad: item }, null, 8, ["ad"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ], 512)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasLocations)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('AdListSimilar.locations')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (item, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    target: "_blank",
                    href: item.link
                  }, _toDisplayString(item.title), 9, _hoisted_9))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}